import { call, put, select, takeEvery } from "redux-saga/effects";
import {
  FETCH_JOB_PORTAL_JOB_LIST,
  FETCH_JOB_PORTAL_JOB,
  FETCH_JOB_PORTAL_WORK_LOCATIONS,
  PARSE_JOB_PORTAL_RESUME,
  POST_JOB_PORTAL_JOB_APPLICATION,
  FETCH_JOB_PORTAL_JOB_NO_FILTER,
} from "./actionTypes";
import {
  fetchJobPortalJobListSuccess,
  fetchJobPortalJobListFailure,
  fetchJobPortalJobSuccess,
  fetchJobPortalJobFailure,
  fetchJobPortalWorkLocationsSuccess,
  fetchJobPortalWorkLocationsFailure,
  parseJobPortalResumeSuccess,
  parseJobPortalResumeFailure,
  postJobPortalJobApplicationSuccess,
  postJobPortalJobApplicationFailure,
  fetchJobPortalJobNoFilterFailure,
  fetchJobPortalJobNoFilterSuccess,
} from "./action";
import {
  getJobList,
  getJob,
  getWorkLocations,
  parseResume,
  postJobApplication,
  getJobNofilter,
} from "../../helpers/backend_helper";

// Get redux state variable
const getSearch = (state) => state.JobPortalJobReducer.search;
const getFilter = (state) => state.JobPortalJobReducer.filter;

// Fetch All Jobs
function* workFetchJobPortalJobList(action) {
  const search = yield select(getSearch);
  const filter = yield select(getFilter);
  const searchFilter = { ...search, ...filter };
  try {
    const response = yield call(getJobList, action.payload, searchFilter);
    yield put(fetchJobPortalJobListSuccess(response));
  } catch (error) {
    yield put(fetchJobPortalJobListFailure(error));
  }
}

// Fetch Job by jobId
function* workFetchJobPortalJob(action) {
  try {
    const response = yield call(getJob, action.payload);
    yield put(fetchJobPortalJobSuccess(response));
  } catch (error) {
    yield put(fetchJobPortalJobFailure(error));
  }
}

// Fetch work locations
function* workFetchJobPortalWorkLocations() {
  const search = yield select(getSearch);
  const filter = yield select(getFilter);
  const countryLocation = {
    country: search.country,
    locations: [...filter.locations],
  };
  try {
    const response = yield call(getWorkLocations, countryLocation);
    yield put(fetchJobPortalWorkLocationsSuccess(response));
  } catch (error) {
    yield put(fetchJobPortalWorkLocationsFailure(error));
  }
}

// Parse Candidate Resume
function* workParseJobPortalResume(action) {
  try {
    const response = yield call(parseResume, action.payload);
    yield put(parseJobPortalResumeSuccess(response.data[0].data));
  } catch (error) {
    yield put(parseJobPortalResumeFailure(error));
  }
}

// Post Candidate Application
function* workPostJobPortalJobApplication(action) {
  const { formData, jobId } = action.payload;
  try {
    const response = yield call(postJobApplication, formData, jobId);
    yield put(postJobPortalJobApplicationSuccess(response));
  } catch (error) {
    yield put(postJobPortalJobApplicationFailure(error));
  }
}

// Fetch Job by ID no filter
function* workFetchJobPortalJobNoFilter(action) {
  try {
    const response = yield call(getJobNofilter, action.payload);
    yield put(fetchJobPortalJobNoFilterSuccess(response));
  } catch (error) {
    yield put(fetchJobPortalJobNoFilterFailure(error));
  }
}

// Watchers
export default function* watchFetchJobPortalJobSaga() {
  yield takeEvery(FETCH_JOB_PORTAL_JOB_LIST, workFetchJobPortalJobList);
  yield takeEvery(FETCH_JOB_PORTAL_JOB, workFetchJobPortalJob);
  yield takeEvery(FETCH_JOB_PORTAL_WORK_LOCATIONS, workFetchJobPortalWorkLocations);
  yield takeEvery(PARSE_JOB_PORTAL_RESUME, workParseJobPortalResume);
  yield takeEvery(POST_JOB_PORTAL_JOB_APPLICATION, workPostJobPortalJobApplication);
  yield takeEvery(FETCH_JOB_PORTAL_JOB_NO_FILTER, workFetchJobPortalJobNoFilter);
}
